import { createUseStyles } from 'react-jss';
import { Dialog, styled, Theme } from '@mui/material';
import { ITheme } from '../../theme';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const iconButtonStyles = {
  position: 'absolute',
  right: 8,
  top: 8,
  color: (theme: Theme): string => theme.palette.grey[500],
};

export const dialogStyles = { m: 0, p: 2 };

type RuleNames =
  | 'uploadBtn'
  | 'modal'
  | 'modalTitle'
  | 'modalDescription'
  | 'modalMainTitle';

const PREFIX = 'ModalSuccess';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      modal: {
        '& .MuiDialog-paper': {
          width: '780px',
          maxWidth: '780px',
          borderRadius: '20px',
        },
        '& .MuiDialogContent-root': {
          padding: '28px 40px 20px 40px',
        },
        '& .MuiDialogTitle-root': {
          padding: '60px 40px 0',
        },
        '& .MuiDialogActions-root': {
          padding: '10px 20px 30px 40px',
        },
        '& .MuiSvgIcon-root': {
          width: '1.5em',
          height: '1.5em',
        },
        '& .MuiIconButton-root': {
          margin: '35px 25px',
        },
        '& .MuiOutlinedInput-root': {
          fontFamily: theme.sfPro,
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
            },
          },
        },
        '& .MuiFormLabel-root': {
          marginLeft: -3,
          '&.Mui-focused': {
            color: 'black',
          },
        },
      },
      uploadBtn: {
        backgroundColor: theme.black,
      },
      modalTitle: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '20px',
        margin: '20px 16px',
      },
      modalMainTitle: {
        fontFamily: theme.caslonDoric,
        color: theme.darkGreen,
        fontSize: '36px',
        fontWeight: 600,
      },
      modalDescription: {
        fontSize: '20px',
      },
    }
  ),
  { name: PREFIX },
);
